var _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJisomeeMeter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.405,
    height: 64.405,
    viewBox: "0 0 64.405 64.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2,0A32.2,32.2,0,1,0,64.4,32.2,32.2,32.2,0,0,0,32.2,0Zm0,61.1A28.894,28.894,0,1,1,61.1,32.2,28.894,28.894,0,0,1,32.2,61.1Z",
    fill: "#1787e0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.909,21.295a4.615,4.615,0,1,0-4.615,4.615,4.615,4.615,0,0,0,4.615-4.615Zm-5.921,0A1.307,1.307,0,1,1,21.295,22.6a1.307,1.307,0,0,1-1.307-1.307Z",
    transform: "translate(10.908 10.908)",
    fill: "#efc700"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.664,
    height: 6.93,
    rx: 0.25,
    transform: "translate(21.27 17.052)",
    fill: "#1787e0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.664,
    height: 6.93,
    rx: 0.25,
    transform: "translate(26.562 17.052)",
    fill: "#1787e0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.664,
    height: 6.93,
    rx: 0.25,
    transform: "translate(31.855 17.052)",
    fill: "#1787e0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4.664,
    height: 6.93,
    rx: 0.25,
    transform: "translate(37.148 17.052)",
    fill: "#1787e0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.124,10.305a1.654,1.654,0,0,0,1.654-1.654V4.864a1.654,1.654,0,0,0-3.308,0V8.651A1.654,1.654,0,0,0,20.124,10.305Z",
    transform: "translate(12.078 2.099)",
    fill: "#1787e0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.556,9.463a1.654,1.654,0,0,0,1.654,1.224,1.8,1.8,0,0,0,.43,0,1.654,1.654,0,0,0,1.174-2.018l-.976-3.655a1.679,1.679,0,1,0-3.258.81Z",
    transform: "translate(9.502 2.446)",
    fill: "#1787e0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.951,11.032a1.654,1.654,0,1,0,2.861-1.654L13.927,6.07A1.647,1.647,0,1,0,11.1,7.757Z",
    transform: "translate(7.094 3.424)",
    fill: "#1787e0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.744,13.076a1.655,1.655,0,1,0,2.332-2.349L10.413,8.114a1.654,1.654,0,0,0-2.3,2.3Z",
    transform: "translate(5.117 5.117)",
    fill: "#1787e0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.085,13.918,9.392,15.8a1.653,1.653,0,1,0,1.654-2.861L7.739,11.09a1.638,1.638,0,1,0-1.654,2.828Z",
    transform: "translate(3.442 7.104)",
    fill: "#1787e0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.961,17.774l3.655.976a1.8,1.8,0,0,0,.413,0,1.668,1.668,0,0,0,.43-3.308l-3.639-.86a1.653,1.653,0,0,0-.86,3.192Z",
    transform: "translate(2.448 9.499)",
    fill: "#1787e0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.651,21.778a1.654,1.654,0,1,0,0-3.308H4.864a1.654,1.654,0,0,0,0,3.308Z",
    transform: "translate(2.099 12.078)",
    fill: "#1787e0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.64,23.056a1.654,1.654,0,0,0-2.018-1.174l-3.655.976a1.657,1.657,0,0,0,.48,3.258,1.8,1.8,0,0,0,.43,0l3.655-.992a1.654,1.654,0,0,0,1.108-2.067Z",
    transform: "translate(2.442 14.274)",
    fill: "#1787e0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.643,25.79a1.654,1.654,0,0,0-2.266-.612L6.069,27.064a1.66,1.66,0,1,0,1.654,2.878l3.308-1.9a1.654,1.654,0,0,0,.612-2.249Z",
    transform: "translate(3.424 16.319)",
    fill: "#1787e0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.155,28.133a1.654,1.654,0,0,0-2.349,0L8.193,30.8a1.662,1.662,0,0,0,2.3,2.4l2.663-2.729A1.654,1.654,0,0,0,13.155,28.133Z",
    transform: "translate(5.038 18.078)",
    fill: "#1787e0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.221,29.93a1.654,1.654,0,0,0-2.266.6L11.07,33.833a1.653,1.653,0,1,0,2.861,1.654l1.885-3.308A1.654,1.654,0,0,0,15.221,29.93Z",
    transform: "translate(7.091 19.424)",
    fill: "#1787e0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.576,31.022A1.654,1.654,0,0,0,15.558,32.2l-.976,3.788A1.654,1.654,0,0,0,15.74,38a1.356,1.356,0,0,0,.43,0,1.654,1.654,0,0,0,1.654-1.224l.976-3.655a1.654,1.654,0,0,0-1.224-2.1Z",
    transform: "translate(9.499 20.251)",
    fill: "#1787e0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.124,31.44a1.654,1.654,0,0,0-1.654,1.654v3.788a1.654,1.654,0,1,0,3.308,0V33.094A1.654,1.654,0,0,0,20.124,31.44Z",
    transform: "translate(12.078 20.56)",
    fill: "#1787e0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.075,32.244a1.647,1.647,0,1,0-3.192.81l.976,3.655a1.654,1.654,0,0,0,1.654,1.224,1.356,1.356,0,0,0,.43,0,1.654,1.654,0,0,0,1.125-1.952Z",
    transform: "translate(14.272 20.252)",
    fill: "#1787e0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.026,30.5a1.654,1.654,0,0,0-2.861,1.654l1.885,3.308a1.66,1.66,0,0,0,2.878-1.654Z",
    transform: "translate(16.333 19.446)",
    fill: "#1787e0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.429,28.1A1.654,1.654,0,0,0,28.1,30.429l2.663,2.729a1.678,1.678,0,1,0,2.4-2.349Z",
    transform: "translate(18.114 18.114)",
    fill: "#1787e0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.445,27.05l-3.308-1.885a1.654,1.654,0,0,0-1.654,2.861l3.308,1.9a1.66,1.66,0,0,0,1.654-2.878Z",
    transform: "translate(19.433 16.333)",
    fill: "#1787e0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.741,22.859l-3.655-.976a1.653,1.653,0,1,0-.86,3.192l3.655.992a1.9,1.9,0,0,0,.43,0,1.624,1.624,0,0,0,.43-3.209Z",
    transform: "translate(20.27 14.272)",
    fill: "#1787e0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.881,18.47H33.094a1.654,1.654,0,0,0,0,3.308h3.788a1.654,1.654,0,1,0,0-3.308Z",
    transform: "translate(20.56 12.078)",
    fill: "#1787e0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.019,17.572a1.654,1.654,0,0,0,1.654,1.24,2.1,2.1,0,0,0,.43,0l3.655-.976a1.675,1.675,0,0,0-.777-3.258l-3.655.976a1.654,1.654,0,0,0-1.307,2.018Z",
    transform: "translate(20.254 9.503)",
    fill: "#1787e0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.93,15.233a1.654,1.654,0,0,0,2.249.6l3.308-1.885a1.654,1.654,0,1,0-1.654-2.861l-3.308,1.885a1.654,1.654,0,0,0-.6,2.266Z",
    transform: "translate(19.424 7.078)",
    fill: "#1787e0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M28.13,13.155a1.657,1.657,0,0,0,2.332,0l2.729-2.663a1.643,1.643,0,0,0-2.349-2.3l-2.712,2.63A1.654,1.654,0,0,0,28.13,13.155Z",
    transform: "translate(18.081 5.038)",
    fill: "#1787e0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M25.79,11.643a1.654,1.654,0,0,0,2.249-.612l1.9-3.308a1.66,1.66,0,0,0-2.878-1.654L25.178,9.377a1.654,1.654,0,0,0,.612,2.266Z",
    transform: "translate(16.319 3.424)",
    fill: "#1787e0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.054,10.636a1.9,1.9,0,0,0,.43,0,1.654,1.654,0,0,0,1.654-1.224l.926-3.589a1.659,1.659,0,1,0-3.209-.844L21.88,8.635A1.654,1.654,0,0,0,23.054,10.636Z",
    transform: "translate(14.275 2.447)",
    fill: "#1787e0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.744,24.52a1.654,1.654,0,0,0,0,3.308h4.532a1.654,1.654,0,0,0,0-3.308Z",
    transform: "translate(12.484 16.035)",
    fill: "#1787e0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.52,28.844a.347.347,0,0,0,.182.364.314.314,0,0,0,.165,0,.463.463,0,0,0,.215,0,.364.364,0,0,0,.265.3h.083a.4.4,0,0,0,.281-.149.347.347,0,0,0,.331.232.364.364,0,0,0,.331-.232.331.331,0,0,0,.265.149h.1a.38.38,0,0,0,.248-.3.463.463,0,0,0,.215,0,.38.38,0,0,0,.182,0,.331.331,0,0,0,.165-.364h.132a.364.364,0,0,0,.248-.1.331.331,0,0,0,0-.4h0a.347.347,0,0,0,.314-.182.331.331,0,0,0,0-.4.314.314,0,0,0,.3-.248.364.364,0,0,0-.116-.364.364.364,0,0,0,0-.662.364.364,0,0,0,.116-.364.38.38,0,0,0-.281-.265.363.363,0,0,0-.38-.546.331.331,0,0,0,0-.4.347.347,0,0,0-.38,0,.331.331,0,0,0-.165-.364.347.347,0,0,0-.4,0,.347.347,0,0,0-.628-.165.349.349,0,0,0-.645,0,.347.347,0,0,0-.364-.132.364.364,0,0,0-.265.3.331.331,0,0,0-.38,0,.347.347,0,0,0-.182.364.347.347,0,0,0-.38,0,.38.38,0,0,0,0,.4.347.347,0,0,0-.38.165.38.38,0,0,0,0,.38.38.38,0,0,0-.281.265.364.364,0,0,0,.116.364.364.364,0,0,0,0,.662.364.364,0,0,0-.116.364.331.331,0,0,0,.3.248.381.381,0,0,0,.314.579h0a.331.331,0,0,0,0,.4.364.364,0,0,0,.248.1A.314.314,0,0,0,25.52,28.844Z",
    transform: "translate(15.912 15.812)",
    fill: "#efc700"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJisomeeMeter);
export default __webpack_public_path__ + "static/media/jisomee_meter.80949c3b40221ecfd16dd21ee98470e8.svg";
export { ForwardRef as ReactComponent };